import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseFormComponent } from '@classes/extends';
import { CommunesComponent, SelectGala } from '@composants/index';
import { FormValidator } from '@composants/validators';
import {
    Organisme, OrganismeService as OrganismesService, Pays, Profil, ProfilService, RFFonction, RFParam, Sig,
    Telephone, Utilisateur, UtilService as UtilisateurService
} from '@estel-numerique/galaclick-api';
import { lastValueFrom } from 'rxjs';
import { KeycloakAuthService } from '../../services/keycloak-auth.service';
import { Constantes } from '../../services/util/constantes';
import { DialogGalaComponent } from '../composants/dialog-gala/dialog-gala.component';
import { AccordionGalaComponent } from '../composants/accordion-gala/accordion-gala.component';
import { AccordionGalaItemComponent } from '../composants/accordion-gala/accordion-gala-item/accordion-gala-item.component';
import { AccordionGalaItemHeadComponent } from '../composants/accordion-gala/accordion-gala-item-head/accordion-gala-item-head.component';
import { AccordionGalaItemBodyComponent } from '../composants/accordion-gala/accordion-gala-item-body/accordion-gala-item-body.component';
import { SelectGala as SelectGala_1, SelectPhoneGala } from '../composants/select/select.component';
import { InputGala } from '../composants/inputs/input.component';
import { CommunesComponent as CommunesComponent_1 } from '../composants/communes.component';
import { DateGalaComponent } from '../composants/date-gala/date-gala.component';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { DateFormatPipe } from '../../services/util/pipe';

/**
  * Modal MonCompte
  */
@Component({
    selector: 'moncompte-modal',
    templateUrl: './moncompte.component.html',
    styleUrls: ['./moncompte.component.css'],
    imports: [
        DialogGalaComponent, AccordionGalaComponent, AccordionGalaItemComponent, AccordionGalaItemHeadComponent, AccordionGalaItemBodyComponent, FormsModule, ReactiveFormsModule,
        SelectGala_1, InputGala, CommunesComponent_1, SelectPhoneGala, DateGalaComponent, NgClass, MatButton, DateFormatPipe
    ]
})
export class MonCompteComponent extends BaseFormComponent implements OnInit {
    private formBuilder = inject(FormBuilder);
    private wsProfil = inject(ProfilService);
    private wsOrga = inject(OrganismesService);
    private wsUtil = inject(UtilisateurService);
    protected keycloakAuth = inject(KeycloakAuthService);
    private dialogRef = inject<MatDialogRef<MonCompteComponent>>(MatDialogRef);
    public data = inject<Utilisateur>(MAT_DIALOG_DATA);

    @ViewChild('communeGala') public communeComp: CommunesComponent;

    //    @Output() BDDchanges = new EventEmitter();
    @Input() public titre: string;

    protected listePAYS: Pays[];
    protected listeTYPETEL: RFParam[] = [];
    protected listeCIVILE: RFParam[] = [];
    protected listePROFILS: { value: Profil; label: string }[] = [];
    protected listePROFILSAVE: { value: Profil; label: string }[] = [];
    protected listeORGA: Organisme[] = [];
    protected listeFONCTION: RFFonction[];
    protected listeSIG: Organisme[];
    protected listeSIGSAVE: Organisme[];
    protected lgTrad: Record<string, string>;

    /** Session ouverte en incarnant l'utilisateur */
    protected get sessionIncarnee(): boolean {
        return !!this.data.INCARNEPAR;
    }

    protected DDebut = "";
    protected DFin = "";

    protected classPwdCtrl = "";

    protected typeEmployeurEtFonction: Record<number, string>;
    public codeModule: string = Constantes.CodeOption.OFICHIERUSER; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    @ViewChild('selectProfil') public selectProfil: SelectGala;
    public user: Utilisateur;

    public formData = this.formBuilder.group({
        CIVILITE: [0, Validators.required],
        NOM: ['', [Validators.required, Validators.maxLength(50)]],
        PRENOM: ['', [Validators.required, Validators.maxLength(50)]],
        CODEPAYS: ["FR", Validators.required],
        TYPEUTIL: [{} as RFParam, Validators.required],
        LOGIN: ['', Validators.required],
        PWDOLD: ['', Validators.required],
        PWD1: ['', Validators.minLength(Constantes.PWDMINSIZE)],
        PWD2: [''],
        ADRESSEA: [""],
        ADRESSEB: [""],
        COPOST: ["", [Validators.required]],
        COMMUNE: ["", [Validators.required]],
        CEDEX: [''],
        TYPTEL1: [0, [Validators.required]],
        INDICATIF1: ["+33", Validators.required],
        TEL1: ['', [Validators.required, FormValidator.validTel]],
        TYPTEL2: [0],
        INDICATIF2: ["+33"],
        TEL2: [''],
        MAIL: ['', [Validators.required, Validators.email]]
    });


    constructor() {
        super();
        this.dialogRef.updateSize('900px');
        this.user = this.data;
        this.typeEmployeurEtFonction = { 0: this.translate.instant("APPMONCOMPTE.SECONDAIRE"), 1: this.translate.instant("APPMONCOMPTE.PRINCIPAL") };
        try {
            this.lgTrad = {
                MODIF: this.translate.instant("MODIF"),
                GENEDATAS: this.translate.instant("GENEDATAS"),

                CIVILITY: this.translate.instant("CIVILITY"),
                NAME: this.translate.instant("NAME"),
                COUNTRY: this.translate.instant("COUNTRY"),
                SURNAME: this.translate.instant("SURNAME"),
                ADRESSE: this.translate.instant("ADRESSE"),
                COMPLEMENT: this.translate.instant("COMPLEMENT"),
                MAIL: this.translate.instant("MAIL"),
                DEBUT: this.translate.instant("DEBUT"),
                FIN: this.translate.instant("FIN"),
                BEGINNINGDATE: this.translate.instant("BEGINNINGDATE"),
                ENDDATE: this.translate.instant("ENDDATE"),
                SIGCODE: this.translate.instant("SIGCODE"),
                ORGANISME: this.translate.instant("ORGANISME"),

                RIGHTS: this.translate.instant("APPMONCOMPTE.RIGHTS"),
                APPLICATIF: this.translate.instant("APPMONCOMPTE.APPLICATIF"),
                PROFIL: this.translate.instant("APPMONCOMPTE.PROFIL"),
                AGENTCODE: this.translate.instant("APPMONCOMPTE.AGENTCODE"),
                EMPNFCT: this.translate.instant("APPMONCOMPTE.EMPNFCT"),
                FONCTION: this.translate.instant("APPMONCOMPTE.FONCTION"),
                EMPLOYER: this.translate.instant("APPMONCOMPTE.EMPLOYER"),
                ETP: this.translate.instant("APPMONCOMPTE.ETP"),
                OCTAGRI: this.translate.instant("APPMONCOMPTE.OCTAGRI"),
                OCTAGRICODE: this.translate.instant("APPMONCOMPTE.OCTAGRICODE"),

                LOGIN: this.translate.instant("APPMONCOMPTE.LOGIN"),
                PWDOLD: this.translate.instant("APPMONCOMPTE.PWDOLD"),
                PWD1: this.translate.instant("APPMONCOMPTE.PWD1"),
                CHGPWD: this.translate.instant("APPMONCOMPTE.CHGPWD"),
                PWD2: this.translate.instant("APPMONCOMPTE.PWD2"),
                CTRLNEWPWD: this.translate.instant("APPMONCOMPTE.CTRLNEWPWD"),
                MDPKEYCLOAK: this.translate.instant("APPMONCOMPTE.MDPKEYCLOAK"),
                MDPKEYCLOAKSUPERVISEUR: this.translate.instant("APPMONCOMPTE.MDPKEYCLOAKSUPERVISEUR"),
                MODESUPERVISEUR: this.translate.instant("INCARNATION.MODESUPERVISEUR"),
                COMPTEVERROUILLE: this.translate.instant("APPMONCOMPTE.COMPTEVERROUILLE"),

                ENREGISTRER: this.translate.instant("ENR"),
                RETOUR: this.translate.instant("RET"),
            };
        } catch (e) {
            this.util.fErreur(e);
        }
        if (this.sessionIncarnee) {
            // Le compte de la personne incarnée ne peut pas être modifié
            this.formData.disable();
        }
        if (this.keycloakAuth.actif) {
            // Identifiant et mot de passe sont gérés par Keycloak
            this.formData.controls.LOGIN.disable();
            this.formData.controls.PWDOLD.disable();
            this.formData.controls.PWD1.disable();
            this.formData.controls.PWD2.disable();
        }
    }

    private async chargeListe() {
        await Promise.all([
            lastValueFrom(this.wsCacheLow.getCivilites()),
            lastValueFrom(this.wsCacheLow.getTyptel()),
            lastValueFrom(this.wsProfil.getProfilListe()),
            lastValueFrom(this.wsCacheLow.getPays()),
            lastValueFrom(this.wsCacheLow.getRFFonction()),
            lastValueFrom(this.wsOrga.getOrganismes(true)),
            lastValueFrom(this.wsOrga.getOrganimeChildren(this.user.ORGAOC.IDORGA, true)),
            lastValueFrom(this.wsUtil.getUtil(this.user.USRID))
        ]).then((results) => {
            this.listeCIVILE = results[0];
            this.listeTYPETEL = results[1];
            const profils = results[2];
            this.listePROFILSAVE = profils.map((o: Profil) => ({ value: o, label: o.NOMAPP + ' - ' + o.PROFIL }));
            this.listePROFILS = [...this.listePROFILSAVE];
            this.listePAYS = results[3];
            this.listeFONCTION = results[4];
            this.listeORGA = results[5];
            this.listeSIGSAVE = results[6];
            this.listeSIG = Object.assign([], this.listeSIGSAVE);
            this.user = results[7];
        }).catch((error) => { throw error; });

    }

    ngOnInit() {
        super.ngOnInit();
        this.init().catch(e => this.util.fErreur(e));
    }

    private async init() {
        try {
            this.util.showLoader();

            await this.chargeListe(); // on ne charge que maintenant car dans le init nous n'aurions pas encore de sessionuser


            if (this.user.PROFILS != null) {
                if (this.user.PROFILS.length != 0) {
                    this.user.PROFILS.forEach((profil: Profil) => {
                        this.listePROFILS = this.listePROFILS.filter((o) => {
                            if (o.value.IDAPPLICATIF != profil.IDAPPLICATIF) {
                                return o;
                            }
                        });
                    });
                }
                this.listePROFILS = Object.assign([], this.listePROFILS);
            }

            this.formData.reset(this.user as unknown);
            this.formData.patchValue({
                CIVILITE: this.user.CIVILITE.ID,
                TYPTEL1: this.user.TELA.TYPTEL,
                TYPTEL2: this.user.TELB.TYPTEL,
                TEL1: this.util.telephone.fTelAddSep(this.user.TELA),
                TEL2: this.util.telephone.fTelAddSep(this.user.TELB),
                INDICATIF1: this.user.TELA.INDICATIF,
                INDICATIF2: this.user.TELB.INDICATIF,
                LOGIN: this.user.LOGIN,
                PWDOLD: '',
                PWD1: '',
                PWD2: ''
            });
            this.DDebut = this.user.DDEBUT;
            this.DFin = this.user.DFIN;

            if (this.user.LISTESIG != null) {
                //Suppression des SIG dans le tableau
                this.user.LISTESIG.forEach((userSig: Sig) => {
                    this.listeSIG = this.listeSIG.filter((sig: Sig) => {
                        return sig.IDORGA != userSig.IDORGA;
                    });
                });
            }

            this.initFormValues();

            await this.util.delay(100);
            if (this.communeComp != null) {
                this.communeComp.initCommuneCopost(this.user);
            }

            this.formData.markAsUntouched();
            this.formData.markAsPristine();
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }


    /**
     * Si les données du formulaire sont valident, ajoute l'organisme à la liste des organismes
     */
    async save() {
        if (this.sessionIncarnee) {
            return;
        }
        this.util.showLoader();

        try {
            //Booléen de confirmation de validation du formulare (utiulisé par exemple pour confirmer validation des etp non a 100%)
            let boConfirmForm = true;

            this.validationFormulaire(this.formData);

            if (!this.keycloakAuth.actif) {
                // Contrôle si le log/pass précédent est ok
                if (await this.checkLogPass() == false) {
                    boConfirmForm = false;
                }

                // Contrôle si le login est déjà utilisé
                if (await this.isLOGINUsed() == true) {
                    boConfirmForm = false;
                }

                // Contrôle si les 2 nouveaux passwords sont identique (nouveau MDP et contrôle)
                if (this.checkNewPWD() == false) {
                    boConfirmForm = false;
                }
            }

            if (this.formData.valid && boConfirmForm) {


                if (this.user.LOGIN.toUpperCase() != this.formData.getRawValue().LOGIN.toUpperCase()) {
                    this.util.fConfirm(this.translate.instant("APPMONCOMPTE.CONFCHANGELOGIN"), () => {
                        this.saveData(true).catch(e => this.util.fErreur(e));;
                    });
                } else {
                    await this.saveData(false);
                }
            }
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    private async saveData(bChangeLogin: boolean) {
        try {
            //On map le form sur la valeur que l'on va renvoyé au webservice
            const oData = Object.assign({}, this.user, this.formData.value);
            //On recrée les objets qui ne sont plus complet

            //TEL
            let tel: Telephone = { TYPTEL: null, INDICATIF: null, NUMERO: null };
            tel.NUMERO = this.util.telephone.fTelStrip(oData.TEL1);
            tel.TYPTEL = oData.TYPTEL1;
            tel.INDICATIF = oData.INDICATIF1;
            oData.TELA = tel;

            tel = { TYPTEL: null, INDICATIF: null, NUMERO: null };
            tel.NUMERO = this.util.telephone.fTelStrip(oData.TEL2);
            tel.TYPTEL = oData.TYPTEL2;
            tel.INDICATIF = oData.INDICATIF2;
            oData.TELB = tel;

            delete oData.TYPTEL1;
            delete oData.TYPTEL2;
            delete oData.INDICATIF1;
            delete oData.INDICATIF2;
            delete oData.TEL1;
            delete oData.TEL2;

            delete oData.PWDOLD;
            delete oData.PWD1;
            delete oData.PWD2;

            if (this.formData.value.PWD1) {
                oData.PASS = this.formData.value.PWD1;
            }

            //COMMUNE
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            oData.COMMUNE = (oData.COMMUNE as any).value as string;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            oData.COPOST = (oData.COPOST as any).value as string;

            //CIVILITE
            const param: RFParam = { ID: oData.CIVILITE, LIB: null, CODE: null };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (oData as any).CIVILITE = param;
            await lastValueFrom(this.wsUtil.putUtilLite(this.user.USRID, oData));

            this.hideModal(true);
            this.util.showToastSuccess(this.translate.instant("APPUTILISATEUR.MODIFSUCCESS"));

            if (bChangeLogin == true) {
                this.deco();
                this.router.navigate([Constantes.URLAUTH]).catch(e => this.util.fErreur(e));
            } else {
                // TODO : Revoir ce fonctionnement (plutot un observable ?)
                // Sauvegarde en session les nouvelles données
                const userTmp: Utilisateur = JSON.parse(sessionStorage.getItem("user")) as Utilisateur;

                const bReload: boolean = (userTmp.NOM != oData.NOM || userTmp.PRENOM != oData.PRENOM);

                userTmp.CIVILITE = oData.CIVILITE;
                userTmp.PAYS = oData.PAYS;
                userTmp.NOM = oData.NOM.toUpperCase();
                userTmp.PRENOM = oData.PRENOM;
                userTmp.ADRESSEA = oData.ADRESSEA;
                userTmp.ADRESSEB = oData.ADRESSEB;
                userTmp.MAIL = oData.MAIL.toLowerCase();
                userTmp.CEDEX = oData.CEDEX;
                userTmp.COPOST = oData.COPOST;
                userTmp.COMMUNE = oData.COMMUNE;

                userTmp.TELA = oData.TELA;
                userTmp.TELB = oData.TELB;

                sessionStorage.setItem("user", JSON.stringify(userTmp));

                this.sessionUser = this.getUserSession();


                // Pour refresh le nom/prenom sur la page d'accueil on doit la refresh (si on est sur un module, ça va se refresh auto en changeant de page)


                if (bReload) {
                    location.reload();
                }
            }
        } catch (e) {
            this.util.fErreur(e);
        }
    }

    /** Ouvre la page Keycloak de modification du mot de passe */
    public modifierMotDePasse() {
        this.keycloakAuth.modifierMotDePasse().catch(e => this.util.fErreur(e));
    }

    public hideModal(force?: boolean) {
        if (!force && !this.formData.untouched) {
            this.util.fConfirm(this.translate.instant("QUITNOSAVE"), () => { this.hideModal(true); }, this.translate.instant("MODIFDONE"));
        } else {
            this.listePROFILS = Object.assign([], this.listePROFILSAVE);
            this.dialogRef.close();
        }
    }

    public initFormValues() {
        let typeTel1 = this.formData.value.TYPTEL1;
        let typeTel2 = this.formData.value.TYPTEL2;
        if (typeTel1 == null) {
            typeTel1 = this.util.getParamByCode(this.listeTYPETEL, "PPR").ID;
        }
        if (typeTel2 == null) {
            typeTel2 = this.util.getParamByCode(this.listeTYPETEL, "PPR").ID;
        }
        this.formData.patchValue({
            TYPTEL1: typeTel1,
            TYPTEL2: typeTel2,
            TYPEUTIL: this.user.TYPEUTIL
        });
    }

    public async isLOGINUsed() {
        try {
            let login = this.formData.value.LOGIN;
            if (login != null) {
                login = login.toUpperCase();
                if (login.trim() != "") {
                    if (await lastValueFrom(this.wsUtil.checkIfLoginIsUsed(login, this.user.USRID)) == true) {
                        this.util.showToastError(this.translate.instant("FORMERROR.MSGSTART") + this.translate.instant("FORMERROR.LOGIN") + this.translate.instant("FORMERROR.LOGINUSED"));
                        return true;
                    }
                }
            }
        } catch (e) {
            this.util.fErreur(e);
        }
        return false;
    }

    public async checkLogPass() {
        // Le logPass est un base64 = login + "log|pass" + password
        try {
            const oldPass = this.formData.value.PWDOLD;
            if (oldPass == null || oldPass.trim() == "") {
                return false;
            }
            const logPass = this.user.LOGIN.trim().toUpperCase() + "log_pwd" + oldPass.trim();
            if (await lastValueFrom(this.wsUtil.checkLogPass(this.user.USRID, btoa(logPass))) == true) {
                return true;
            } else {
                this.util.showToastError(this.translate.instant("APPMONCOMPTE.MSGERRCTRLLOGPASS"));
                return false;
            }
        } catch (e) {
            this.util.fErreur(e);
        }
        return false;
    }

    public setListSIG(list: Sig[] = this.listeSIG) {
        this.listeSIG = Object.assign([], list);
    }

    public onChangePays(valueSelected: string) {
        try {
            if (valueSelected != null) {
                if (valueSelected.trim() != "") {
                    const indicatif = this.listePAYS.find((pays) => { return pays.COPAIP == valueSelected; }).INDICATIF;
                    this.formData.patchValue({
                        INDICATIF1: indicatif,
                        INDICATIF2: indicatif
                    });
                }
            } else {
                this.formData.patchValue({
                    INDICATIF1: null,
                    INDICATIF2: null
                });
            }
        } catch (e) {
            this.util.fErreur(e);
        }
    }

    /**
     * Fonction de controle de changement de mot de passe (mot de passe identique)
     *
     * @param sChampSortie indique le champ duquel on sort (Si vide, lance le contrôle)
     */
    public checkNewPWD(sChampSortie = "") {
        this.classPwdCtrl = '';
        const pwd1 = this.formData.value.PWD1.trim();
        const pwd2 = this.formData.value.PWD2.trim();
        this.formData.patchValue({ PWD1: pwd1, PWD2: pwd2 });

        // Si ils sont vide tous les 2 c'est ok, on ne change pas de password
        if (pwd1.length == 0 && pwd2.length == 0) {
            this.classPwdCtrl = '';
            return true;
        }

        if ((sChampSortie == "" && (pwd1.length > 0 || pwd2.length > 0)) ||
            (sChampSortie.toUpperCase() == "PWD1" && pwd2.length > 0) ||
            (sChampSortie.toUpperCase() == "PWD2" && pwd1.length > 0)) {

            if (pwd1 !== pwd2) {
                this.util.showToastError(this.translate.instant("APPMONCOMPTE.MSGERRPWD"));
                this.classPwdCtrl = 'ERR';
                return false;
            } else {
                this.classPwdCtrl = 'OK';
            }
        }

        return true;
    }
}
